import { render } from "./DisplayText.vue?vue&type=template&id=5193b158"
import script from "./DisplayText.vue?vue&type=script&lang=js"
export * from "./DisplayText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__